import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/logo-sm.png'


const _withScopeId = n => (_pushScopeId("data-v-7786073a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settle-form" }
const _hoisted_2 = { class: "settle-form-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settle-form-header-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("div", { class: "settle-form-header-title__text" }, "注册中财捷")
], -1))
const _hoisted_4 = { class: "settle-form-inputs" }
const _hoisted_5 = {
  key: 0,
  class: "form-item__info"
}

import { ref, reactive, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Button, Popup, Field, Form, Toast } from 'vant'
import { updateWxUser, sendUserPhoneNumber } from '@/api/user'
import { useUserStore } from '@/store/modules/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'MRegisterPhone',
  setup(__props) {

const userStore = useUserStore()
const route = useRoute()
const isSend = ref(false)
const countdownSeconds = ref(60)
const buttonText = ref('获取验证码')

const state = reactive({
  popupVisible: false,
  isSubmit: false,
  isResisterSuccess: false, // 是否注册成功
})
const field = reactive({
  realName: {
    value: '',
    error: false,
    validator: (val) => {
      const reg = /^[\u4e00-\u9fa5]{1,8}$/.test(val)
      if (reg === true) field.realName.error = false
      return reg
    },
  },
  phoneNumber: {
    value: '',
    error: false,
    validator: (val) => {
      console.log('phoneNumber==>')
      const reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          val
        )
      if (reg === true) field.phoneNumber.error = false
      return reg
    },
  },
  code: {
    value: '',
    error: false,
    validator: (val) => {
      const reg = /^.+$/.test(val)
      if (reg === true) field.code.error = false
      return reg
    },
  },
})

const handleGetVerificationCode = async () => {
  if (!field.phoneNumber.value) return Toast('请输入手机号码')
  const res = await sendUserPhoneNumber({
    phoneNumber: field.phoneNumber.value,
  })
  if (res.ret === 100) {
    Toast('验证码已发送')
    isSend.value = true
    let i = 60
    let timer = setInterval(() => {
      i--
      countdownSeconds.value = i
      if (i < 0) {
        isSend.value = false
        buttonText.value = '重新获取验证码'
        countdownSeconds.value = 60
        clearInterval(timer)
      }
    }, 1000)
  }
}

// 存在成交订单但未注册手机号码
const show = computed(() => {
  // 邀请注册优先级高于订单注册
  if (route.name === 'invite-to-follow') return false
  return (
    userStore.popupRegisterPhone &&
    userStore.userInfo.isDeal &&
    !state.isResisterSuccess
  )
})

const onSubmit = async (value) => {
  if (state.isSubmit) return false
  console.log('onSubmit==>', value)
  const uid: any = route.params.uid || ''
  const params = {
    ...value,
  }
  if (uid) params.inviteeId = uid
  // const reg = /\d/g
  // if (!reg.test(uid?.trim())) {
  //   Toast('邀请链接已失效，注册失败')
  //   return false
  // }
  state.isSubmit = true
  const { ret, msg } = await updateWxUser(params)
  if (ret === 100) {
    Toast(msg)
    userStore.closePopupRegisterPhone(true)
    state.isResisterSuccess = true
    state.popupVisible = false
    field.realName.value = ''
    field.phoneNumber.value = ''
    field.code.value = ''
    // 刷新用户信息
    await userStore.getUserInfo()
  }
  state.isSubmit = false
}
const onFailed = (err) => {
  console.log('onFailed==>', err)
  Toast('请输入信息并检查是否有误')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: _unref(show),
    "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(show) ? (show).value = $event : null)),
    round: "",
    position: "bottom",
    style: { height: '268px' },
    "z-index": "2002",
    onClose: _unref(userStore).closePopupRegisterPhone
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Form), {
          "show-error": false,
          "show-error-message": false,
          "validate-trigger": "onBlur",
          onSubmit: onSubmit,
          onFailed: onFailed
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(Button), { "native-type": "submit" }, {
                default: _withCtx(() => [
                  _createTextVNode("提交")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Field), {
                modelValue: field.realName.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((field.realName.value) = $event)),
                name: "realName",
                required: "",
                label: "姓名：",
                placeholder: "请输入姓名",
                rules: [
              {
                validator: field.realName.validator,
                message: '请输入姓名',
              },
            ]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_unref(Field), {
                modelValue: field.phoneNumber.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((field.phoneNumber.value) = $event)),
                name: "phoneNumber",
                required: "",
                label: "手机号码：",
                placeholder: "请输入手机号码",
                rules: [
              {
                validator: field.phoneNumber.validator,
                message: '请输入手机号码',
              },
            ]
              }, {
                button: _withCtx(() => [
                  (isSend.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 获取验证码" + _toDisplayString(countdownSeconds.value) + "s ", 1))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "form-item__info",
                        onClick: handleGetVerificationCode
                      }, _toDisplayString(buttonText.value), 1))
                ]),
                _: 1
              }, 8, ["modelValue", "rules"]),
              _createVNode(_unref(Field), {
                modelValue: field.code.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((field.code.value) = $event)),
                required: "",
                name: "code",
                label: "验证码：",
                placeholder: "请输入验证码",
                rules: [
              {
                validator: field.code.validator,
                message: '请输入验证码',
              },
            ],
                maxlength: "6"
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show", "onClose"]))
}
}

})